import React from 'react';
import './QuillWysiwygLayout.scss';
import './QuillWysiwygLayoutNew.scss';
import { ErrorsWrapper, InputLabel } from 'ui-builder';
import useFeatureToggleService from 'feature-toggle';
import MaxLengthInfo from './MaxLengthInfo';
import BaseQuillLayout from './BaseQuillLayout';
import type { QuillWysiwygLayoutProps } from './BaseQuillLayout';

export type { QuillWysiwygLayoutProps };

export default function QuillWysiwygLayout(props: QuillWysiwygLayoutProps) {
  const { isNewWysiwygStylesEnabled } = useFeatureToggleService();

  return (
    <div className={isNewWysiwygStylesEnabled() ? 'new-wysiwyg-styles' : undefined}>
      <ErrorsWrapper name={props.name} errors={props.errors}>
        <InputLabel source={props.name} label={props.label} hideLabel={props.hideLabel} />
        <BaseQuillLayout
          {...props}
        />
        <MaxLengthInfo name={props.name} value={props.value || ''} />
      </ErrorsWrapper>
    </div>
  );
}
